<template lang="pug">
form(@submit.prevent="onFilter")
  .columns.align-center
    .column.col-auto(v-if="isEnabledFilter('inicia_em_gteq')")
      .pb-1
        small {{ filters.inicia_em_gteq }}
        datepicker(v-model="q.inicia_em_gteq" placeholder='Data início' input-class='form-input input-sm')
    .column.col-auto(v-if="isEnabledFilter('termina_em_lteq')")
      .pb-1
        small {{ filters.termina_em_lteq }}
        datepicker(v-model="q.termina_em_lteq" placeholder='Data final' input-class='form-input input-sm')
    .column.col-auto(v-if="isEnabledFilter('ausente_id_eq')")
      .pb-1
        small {{ filters.ausente_id_eq }}
        fiscal-picker(v-model="q.ausente_id_eq" placeholder='Ausente' sm)
    .column.col-auto(v-if="isEnabledFilter('substituto_id_eq')")
      .pb-1
        small {{ filters.substituto_id_eq }}
        fiscal-picker(v-model="q.substituto_id_eq" placeholder='Substituto' sm)
    .column.col-auto.mt-2.pt-2.no-print
      button.mt-2.btn.btn-action.s-circle.btn-sm(type='submit')
        i.fa.fa-filter
      a.mt-2.ml-2.btn.btn-action.s-circle.btn-sm.no-print(onclick="window.print()")
        i.fa.fa-print
    .column.col-auto.mt-2.pt-2.no-print
      enabled-filters.mt-1(
        :localStorageKey='filterKey'
        :defaultEnabledFilters='defaultEnabledFilters'
        :enabledFilters='enabledFilters'
        :filters='filters'
        :query='q'
        :setEnabledFilters='setEnabledFilters'
      )

</template>

<script>
import filterMixin, { defaultStoreImports } from '@/mixins/filter'

export default {
  mixins: [filterMixin],
  vuex: {
    'sistema/ausentes': defaultStoreImports,
  },
  props: {
    filterKey: { type: String, default: 'osm-ausentes' },
  },
  data() {
    return {
      filters: {
        inicia_em_gteq: 'Início maior ou igual a',
        termina_em_lteq: 'Fim menor ou igual a',
        ausente_id_eq: 'Ausente',
        substituto_id_eq: 'Substituto',
      },
      q: {},
      defaultEnabledFilters: [
        'inicia_em_gteq',
        'termina_em_lteq',
        'ausente_id_eq',
        'substituto_id_eq',
      ],
    }
  },
}
</script>
